module.exports = __webpack_public_path__ + "assets/back_small.344f9e9d.svg";